import { useQuery } from '@tanstack/react-query';
import { getProcessedTimesheetDetails } from '../Services/ProcessedTimesheetService';

// Hook to fetch processed timesheet details
const useGetProcessedTimesheetDetails = (params, options) =>
    useQuery(
        ['processedTimesheetDetails', params],
        () => getProcessedTimesheetDetails(params),
        options
    );

export default useGetProcessedTimesheetDetails;
